import {useState, useEffect} from "react";
import {Popup} from 'devextreme-react/popup';
import {Layout, LayoutChild} from "../../../../palette/Palette";
import {Filters} from "../../../../utils/HelpFunctions";
import Text from "../../../../palette/Text"
import {Button} from 'devextreme-react/button';
import List from 'devextreme-react/list'

function HistoryDetails(props) {

    const {popupVisible, setPopupVisible, dataRow, setDataRow} = props

    const [seatingPassenger, setSeatingPassenger] = useState([])

    useEffect(() => {
        if (dataRow.type === 'P') {
            const filterSeating = Filters(dataRow.seating, 'cod', dataRow.cod)
            setSeatingPassenger(filterSeating)
        }
    }, [dataRow])

    let obs = typeof dataRow.observationBooking === 'string' ? [dataRow.observationBooking] : dataRow.observationBooking

    return (
        <>
            <Popup
                visible={popupVisible}
                onHiding={() => setPopupVisible(false)}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showCloseButton={false}
                showTitle={false}
                width={700}
                height={'auto'}
                position={'center'}
            >
                <LayoutChild color={'#FFA95C'} padding={7} width={150}>
                    <Text hover={false} text={`ESTADO :  ${dataRow?.status.toUpperCase()}`} color={'#FFFFFF'}
                          weight="bold" size={10}/>
                </LayoutChild>
                <div style={{border: '1px solid #B0BEC5', marginTop: 12, borderRadius: 3}}>
                    <LayoutChild percent={100} color={'#EEF4FD'} padding={7} row>
                        <LayoutChild percent={50}>
                            {dataRow.type === 'P' &&
                            <Text hover={false} text={`Detalle del viaje reservado para :`} weight="bold" size={16}/>}
                            {dataRow.type === 'E' &&
                            <Text hover={false} text={`Detalle de la encomienda para:`} weight="bold" size={16}/>}
                            {dataRow.type === 'EX' &&
                            <Text hover={false} text={`Detalle del viaje express para:`} weight="bold" size={16}/>}
                            <Text hover={false} text={dataRow.passenger} weight="500" size={15} top={4}/>
                            <Text hover={false} text={`Viaje de ${dataRow.routeName}`} weight="600" size={10}/>
                            <Text hover={false} text={`Fecha : ${dataRow.date} a las ${dataRow.hour} `}
                                  weight="400" size={11} top={3}/>

                        </LayoutChild>
                        <LayoutChild percent={50}>
                            <Layout row center positionR>
                                <Text hover={false} text={`COD :`} weight="700" size={11}/>
                                <Text hover={false} text={`${dataRow.cod}`} weight="700" size={11} color={'#FFA95C'}
                                      left={10}/>
                            </Layout>
                            <Text hover={false} text={`Desde :  ${dataRow.origen}`} weight="600" size={10} top={7}/>
                            <Text hover={false} text={`A :  ${dataRow.destination}`} weight="600" size={10}/>
                            <Text hover={false} text={`Forma de pago :  ${dataRow.wayPay}`} weight="500" size={10}
                                  top={20}/>

                            <LayoutChild row center top={4}>
                                <Text hover={false} text={`TOTAL :`} weight="700" size={11} top/>
                                <Text hover={false} text={`$ ${dataRow.paymentValue}`} weight="700" size={11}
                                      left={10} color={'green'}/>
                            </LayoutChild>
                        </LayoutChild>

                    </LayoutChild>

                    <LayoutChild percent={100} color={'#FAFAFA'} padding={7} row>
                        <LayoutChild percent={50}>
                            <Text hover={false} text={`Vehículo conducido por:`} weight="bold" size={15}/>
                            <Text hover={false} text={dataRow.driver} weight="500" size={13} top={4}/>
                            <div style={{height: 4}}/>
                            <Layout color={'#fafafa'} row center>
                                <Text hover={false} text={`Asientos reservados : `} weight="700" size={11}/>
                                {seatingPassenger.map((seating, i) => {
                                    console.log(seating)
                                    return (
                                        <div key={i}>
                                            {dataRow.type === 'EX' ?
                                                <Text hover={false} text={`Todo el auto`} weight="700"
                                                      size={11} color="#FFA95C" left={7} kye={i}/>
                                                :
                                                <Text hover={false} text={`${seating.description}`} weight="700"
                                                      size={11} color="#FFA95C" left={7} kye={i}/>
                                            }
                                        </div>
                                    )
                                })}
                            </Layout>

                        </LayoutChild>
                        <LayoutChild percent={50}>
                            <Text hover={false} text={dataRow.brand} weight="700" size={13} top={4}/>
                            <Text hover={false} text={`Placa :  ${dataRow.plateNumber.toUpperCase()}`} weight="500"
                                  size={11} top={4}/>
                            <Text hover={false} text={`Color :  ${dataRow.color}`} weight="500" size={11} top={4}/>
                        </LayoutChild>
                    </LayoutChild>

                    <LayoutChild percent={100} color={'#FAFAFA'} padding={7} row top={5}>
                        <LayoutChild percent={50}>
                            <Text hover={false} text={'Datos de facturación'} weight="700" size={13} top={4}/>
                            <LayoutChild row center top={5}>
                                <Text hover={false} text={`Factura a nombre de :`} weight="700" size={11}/>
                                <Text hover={false} text={`${dataRow.invoice.name}`} weight="500" size={11} left={10}/>
                            </LayoutChild>
                            <Text hover={false} text={`RUC : ${dataRow.invoice.RUC}`} weight="500" size={11}/>
                            <Text hover={false} text={`Teléfono : ${dataRow.invoice.contactNumber}`} weight="500"
                                  size={11}/>
                            <Text hover={false} text={`Correo : ${dataRow.invoice.email}`} weight="500" size={11}/>
                            <Text hover={false} text={`Dirección : ${dataRow.invoice.address}`} weight="500" size={11}/>
                        </LayoutChild>
                    </LayoutChild>
                    {dataRow.observation !== '' &&
                    <LayoutChild percent={100} color={'#FAFAFA'} padding={7} row top={2}>
                        <div style={{height: 4}}/>
                        <Layout color={'#fafafa'} padding={12} row center space>
                            <LayoutChild row center top={5}>
                                <Text hover={false} text={`Observación :`} weight="700" size={11}/>
                                <Text hover={false} text={`${dataRow.observation}`} weight="500" size={11} left={10}/>
                            </LayoutChild>
                        </Layout>
                    </LayoutChild>}
                    {dataRow.observationBooking.length > 0 &&
                    <LayoutChild percent={100} color={'#FAFAFA'} padding={7}  top={2} row>
                        <div style={{height: 4}}/>
                        <Text hover={false} text={`Incidentes :`} weight="700" size={11}/>
                        <Text hover={false} text={obs[0]} size={11} left={5}/>
                    </LayoutChild>
                    }
                </div>
                <div style={{height: 4}}/>
                <Layout color={'#FFF'} row positionR>
                    <Button
                        width={120}
                        text="Salir"
                        type="normal"
                        icon={'fas fa-sign-out-alt'}
                        stylingMode="outlined"
                        rtlEnabled={true}
                        onClick={() => {
                            setDataRow(null)
                            setPopupVisible(false)
                        }}
                    />
                </Layout>
            </Popup>
        </>
    )
}

export default HistoryDetails